export const JSON_Bank_Ifcs4 = {    
        "code":"0x0200",
        "message":"Record fetched successfully.",
        "status":"SUCCESS",
        "data":{
            "requestId":"VADR28310891589610079158"
        }    
};

export const JSON_Bank_Ifcs5 = {
    "code":"0x0202",
    "status":"FAILURE",
    "message":"Insufficient funds"    
}

export const JSON_Bank_Ifcs6 = {
    "code":"0x0200",
    "message":"Record fetched successfully.",
    "status":"SUCCESS",
    "data":{
            "requestId":"VADR28310891589610079158",
            "currentStatus":"FOUND",
            "response":{
                "fullName":"Amit Gupta",
                "dob":"2000-01-0",
                "gender":"M",
                "zip":"226000",
                "house":"123",
                "district":"Lucknow",
                "vtc":"Lucknow",
                "loc":"Lucknow",
                "subdistrict":"Bakshi Ka Talab",
                "country":"India",
                "po":"",
                "state":"Uttar Pradesh",
                "street":"Road",
                "profileImage":"\/9j\/4AAQSkZJRgABAgAAAQABAAD\/f\/9k="
            }
        }
}

export const JSON_Bank_Ifcs7 = {
    "code":"0x0202",
    "status":"FAILURE",
    "message":"Invalid request Id."
}